export default __webpack_public_path__ + "static/media/email.8b1de2f4.svg";